import { apiRequest } from "../util/apiUtils";

export const planList = async (params) => {
  try {
    const res = await apiRequest("get", `plan/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const planListFront = async (params) => {
  try {
    const res = await apiRequest("get", `/plan/list-front`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const planAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `plan/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const planDelete = async (payload) => {
  try {
    const res = await apiRequest("patch", `plan/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const planStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `plan/status-change`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const planOrdering = async (payload) => {
  try {
    const res = await apiRequest("patch", `plan/ordering`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
